import { Suspense } from "react";
import { AppLoader } from "./components/Loader";
import RouterComponent from "./Router";

const App = () => {
  return (
    <Suspense fallback={<AppLoader />}>
      <RouterComponent />
    </Suspense>
  );
};

export default App;
